/*
* Atom it's smallest component of the application
* The first letter of name of function should be in capital letter
* @Author STRUCTLOOPER
* */
import React from "react";

export const ContactAdmin=()=> <h1>ENV IS NOT SETUP, CONTACT ADMIN</h1>;
